/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-volume-up-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.975 5.05l-.956.806a6.25 6.25 0 01-.181 8.269l.918.875a7.5 7.5 0 00.219-9.925V5.05zM13.487 7.5a3.75 3.75 0 01-.112 4.963l.919.85a5 5 0 00.143-6.62l-.95.807zM11.25 18.75a.625.625 0 01-.444-.188L6.044 13.75H1.875a.625.625 0 01-.625-.625v-6.25c0-.345.28-.625.625-.625h4.169l4.762-4.813a.625.625 0 01.882 0 .625.625 0 01.187.438v16.25c0 .345-.28.625-.625.625z"/>'
  }
})
